<template>
	<div style="width: 100%;height: 100%;background: #f3f4f9;">
        <LayoutHeader route="enterprise"/>
        <div class="banner-box">
            <img src="@/assets/home/integral-banner.png" alt="">
            <div class="text-box">
                <div class="text1">发现挖掘科技型企业   ·   引导创新资源集聚   ·   助力企业快速成长</div>
                <div class="text2">阳泉高新技术产业开发区企业创新积分</div>
                <div class="button" @click="integralPost">查看我的积分</div>
            </div>
        </div>
        <div class="breadBox">
            <div class="child">
                <a-breadcrumb>
          <span>
            当前位置：
          </span>
                    <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页</a-breadcrumb-item>
                    <a-breadcrumb-item>企业创新积分制</a-breadcrumb-item>
                </a-breadcrumb>
            </div>

        </div>
        <Content1 />
        <Content2 />
        <LayoutFooter />
	</div>
</template>

<script>
import { platformName } from "@/config/platformConfig";
import LayoutHeader from '../../layout/layoutPage/header/LayoutHeaderNew2';
import { sys_policyNotice } from "@/api/adminService";
import { ls } from "@/utils/util"
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
import Content1 from './components/content1'
import Content2 from './components/content2'
import { message } from 'ant-design-vue';
export default {
	name: "index",
	components: {
        LayoutHeader,
		LayoutFooter,
        Content1,
        Content2
	},
	data() {
		return {
			datekey:Date.now(),
			platformName,
			clearHead: true,
			current: ['首页'],
			clickMenuTitle: '',
			formState: {
				user: null,
			},
			policyNotice: {},
			showPolicy: true,
			formSearchBox: {
				city: null,
				company: null,
				project: null,
				demand: null
			}
		}
	},
	mounted(){
		this.getPolicyNotice()
	},
	methods: {
        integralPost() {
            if (ls.get("token") && ls.get("refresh_token")) {
                // this.goMore('/sys/manage', 'user')
                if (ls.get('roleCode').includes('company')) {
                    this.goMore('/sys/manage')
                }else{
                    this.$notification.warning({
                        message: '提示',
                        description: '请使用企业账号登录',
                    })
                }
            } else {
                message.success('请登录后操作')
                this.goMore('/login', 'user',true)
            }
        },
		goMore(url,key) {
			this.$router.push({path: url, query: {type: key}})
		},
		onActiveryMore(url,name,type){

					this.$router.push({
						path:url,
						query:{type:name,activeKey:type}
				})
		},
		getPolicyNotice() {
			this.getAction({
				url: sys_policyNotice.pageList,
				params: { noticeType: '3' }
			}).then(res => {
				if (res.records.length > 0) {
					let obj = res.records[0];
					if (obj.sendStatus == 0 && obj.endTime) {
						// 获取当前日期和时间
						const currentDate = new Date().toLocaleDateString();

						// 创建一个包含当前日期和时间的 Date 对象
						const todayDate = new Date(obj.endTime);

						// 计算两个 Date 对象之间的天数差
						const daysBetween = new Date(todayDate).getTime() - new Date(currentDate).getTime();
						// 如果当前日期超过今天，则打印提示信息
						if (daysBetween > 0) {
							this.showPolicy = true
							this.policyNotice = obj
						} else {
							this.showPolicy = false
						}
					}
					if (!obj.endTime && obj.sendStatus == 0) {
						this.showPolicy = true
						this.policyNotice = obj
					}
				} else {
					this.showPolicy = false
				}
			})
		},
		goPolicyNoticeDetail(record) {
			if (ls.get("token") && ls.get("refresh_token")) {
				if (ls.get("roleCode").includes('company')) {
					if (record.title.indexOf('积分制') > 0) {
						this.$router.push({ path: '/sys/manage' })
					} else if (record.title.indexOf('政策兑现') > 0) {
						this.$router.push({ path: '/sys/policyPublicData' })
					}
				} else {
					this.$router.push({
						path: "/noticeDetail",
						query: { id: record.id, source: 'piao' }
					})
				}
			} else {
				this.goMore('/login', 'user')
			}
			// this.$router.push({
			//   path: "/noticeDetail",
			//   query: { id: id, source: 'piao' }
			// })
		}
	}
}
</script>

<style scoped lang="less">

.banner-box{
    position: relative;
    img{
        width: 100%;
        height: 282px;
        object-fit: cover;
    }
    .text-box{
        position: absolute;
        top: 40px;
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);
        .text1{
            width: 100%;
            font-weight: 400;
            font-size: 20px;
            color: #E0D6FC;
            line-height: 50px;
        }
        .text2{
            width: 100%;
            font-weight: 400;
            font-size: 40px;
            color: #FFFFFF;
            line-height: 50px;
            margin:10px 0 30px 0;
        }
        .button{
            background: linear-gradient(90deg, #FF8F14, #FF5C0A);
            box-shadow: 0px 0px 1px 0px #FFFFFF;
            border-radius: 22px;
            color:#fff;
            width: 160px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
    }
}
.breadBox{
    width: 100%;
    border-bottom: 1px solid #DEDEDE;
    .child{
        width: 1200px;
        margin:0 auto;
        padding:20px 0;

    }
}
</style>
